import dynamic from 'next/dynamic';
import { whatsFlutuanteSempre } from '../../../utils/whatsFlutuanteSempre';

const WhatsAppComponent = dynamic(() => import('./WhatsappComponent'), { ssr: false });

// Páginas que não têm o WhatsApp flutuante (empresa, blog, empreendimento, construtoras) passam a ter
// para quem está em WHATS_FLUTUANTE_SEMPRE_VISIVEL (cs2639). Para os demais não renderiza nada.
const WhatsFlutuanteExtra = ({ site, codsite, origin }: { site: any; codsite?: any; origin?: any }) =>
    whatsFlutuanteSempre(site) ? <WhatsAppComponent site={site} codsite={codsite} origin={origin} /> : null;

export default WhatsFlutuanteExtra;
